import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const Testimonials = () => {
  const { t, tArray } = useCurrency();
  const testimonials = tArray('testimonials.items');

  const renderStars = (rating) => (
    <div className="flex gap-0.5">
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          className={`h-3 w-3 ${i < Math.floor(rating) ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`}
        />
      ))}
    </div>
  );

  return (
    <section className="py-12 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <p className="text-blue-600 font-semibold text-sm uppercase tracking-wider mb-2">
            {t('testimonials.badge')}
          </p>
          <h2
            className="text-3xl font-bold text-slate-900"
            style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
          >
            {t('testimonials.title')}
          </h2>
        </div>

        {/* Testimonials Carousel */}
        <div className="px-12">
          <Carousel
            opts={{
              align: "start",
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent>
              {testimonials.map((testimonial, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3 pl-4">
                  <div className="h-full bg-white rounded-xl p-5 border border-slate-200 hover:shadow-lg transition-shadow flex flex-col">
                    {/* Header */}
                    <div className="flex items-center gap-3 mb-3">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="h-10 w-10 rounded-full object-cover"
                        onError={(e) => {
                          e.target.src = `https://ui-avatars.com/api/?name=${testimonial.name}&background=3b82f6&color=fff`;
                        }}
                      />
                      <div>
                        <h4 className="font-semibold text-slate-900 text-sm">
                          {testimonial.name}
                        </h4>
                        <p className="text-xs text-slate-500">
                          {testimonial.location}
                        </p>
                      </div>
                      <div className="ml-auto">{renderStars(testimonial.rating)}</div>
                    </div>

                    {/* Quote */}
                    <div className="relative flex-grow">
                      <Quote className="absolute -top-1 -left-1 h-4 w-4 text-blue-200" />
                      <p className="text-slate-600 text-sm pl-4 line-clamp-4">
                        {testimonial.review}
                      </p>
                    </div>

                    {/* Car & Services */}
                    <div className="mt-3 pt-3 border-t border-slate-100 flex items-center justify-between">
                      <span className="text-xs text-slate-500">
                        {testimonial.car}
                      </span>
                      <div className="flex gap-1">
                        {testimonial.services?.slice(0, 2).map((service) => (
                          <span
                            key={service}
                            className="px-2 py-0.5 bg-blue-50 text-blue-600 rounded text-xs font-medium"
                          >
                            {service}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

